function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulletList = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _Heading = require("../Heading");
var _View = require("../View");
var _Text = require("../Text");
var _styles2 = require("../../styles");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["items", "title", "titleLevel", "bulletColor", "headingStyle", "itemTextStyle"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var BulletList = exports.BulletList = (0, _react.memo)(function (_ref) {
  var items = _ref.items,
    title = _ref.title,
    _ref$titleLevel = _ref.titleLevel,
    titleLevel = _ref$titleLevel === void 0 ? 3 : _ref$titleLevel,
    bulletColor = _ref.bulletColor,
    headingStyle = _ref.headingStyle,
    itemTextStyle = _ref.itemTextStyle,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var _id = (0, _react.useMemo)(function () {
    return (0, _utils.GenerateId)();
  }, []);
  if (!items || items.length === 0) {
    return null;
  }
  return (0, _jsxRuntime.jsxs)(_View.View, Object.assign({
    testID: "BulletList"
  }, props, {
    children: [title && (0, _jsxRuntime.jsx)(_Heading.Heading, {
      level: titleLevel,
      style: [styles.heading, headingStyle],
      children: title
    }), (0, _jsxRuntime.jsx)(_View.View, {
      spacer: spacing.m,
      accessibilityRole: (0, _utils.WebAccessibilityRole)('list'),
      children: items.map(function (item, index) {
        return (0, _jsxRuntime.jsxs)(_View.View, {
          style: [styles.item],
          accessibilityRole: (0, _utils.WebAccessibilityRole)('listitem'),
          children: [(0, _jsxRuntime.jsx)(_View.View, {
            style: [styles.itemBullet, !!bulletColor && {
              backgroundColor: bulletColor
            }]
          }), (0, _jsxRuntime.jsx)(_Text.Text, {
            containerStyle: styles.itemTextContainer,
            textStyle: [styles.itemText, itemTextStyle],
            children: item
          })]
        }, "BenefitsList-".concat(_id, "-").concat(index));
      })
    })]
  }));
});